import { createSelector } from '@reduxjs/toolkit';
import { selectProjectDomain } from 'reduxStore/project/projectSelector';

export const selectSubProjectsDomain = createSelector(
  selectProjectDomain,
  (projectDomain) => projectDomain?.subProjects,
);
export const selectSubProjectsList = createSelector(
  selectSubProjectsDomain,
  (domain) => domain.list,
);
export const selectSubProjectsPagination = createSelector(
  selectSubProjectsDomain,
  (domain) => domain.pagination,
);
export const selectLiveAndScheduledSurveys = createSelector(
  selectSubProjectsDomain,
  (domain) => domain.liveAndScheduled,
);
export const selectIsPulseTemplateFullyLoaded = createSelector(
  selectProjectDomain,
  (projectDomain) => projectDomain?.isPulseTemplateFullyLoaded ?? false,
);
